import React from 'react';
import { useCanvasStore, tourNotes } from '../store/canvas-store';

export function TourPlayer() {
  const activeTourId = useCanvasStore((s) => s.activeTourId);
  const activeStep = useCanvasStore((s) => s.activeStep);
  const frames = useCanvasStore((s) => s.doc.frames);
  const tours = useCanvasStore((s) => s.doc.tours);
  const tourNext = useCanvasStore((s) => s.tourNext);
  const tourPrev = useCanvasStore((s) => s.tourPrev);
  const endTour = useCanvasStore((s) => s.endTour);

  if (!activeTourId) return null;
  const tour = (tours ?? []).find((t) => t.id === activeTourId);
  const total = tourNotes(frames, activeTourId).length;

  return (
    <div
      style={{
        position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
        zIndex: 900, display: 'flex', alignItems: 'center', gap: 10,
        background: 'var(--color-chip-bg)', border: '1px solid var(--color-chip-border)',
        borderRadius: 999, padding: '6px 12px', fontFamily: 'var(--font-sans)', fontSize: 13,
        color: 'var(--color-text)', boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
      }}
    >
      <span style={{ color: 'var(--color-tool-note)' }}>▶</span>
      <strong>{tour?.title ?? 'Tour'}</strong>
      <span style={{ color: 'var(--color-text-muted)' }}>step {activeStep}/{Math.max(total, 1)}</span>
      <button style={btn} onClick={tourPrev}>‹</button>
      <button style={btn} onClick={tourNext}>›</button>
      <button style={btn} onClick={endTour} title="End tour">✕</button>
    </div>
  );
}

const btn: React.CSSProperties = {
  background: 'transparent', color: 'var(--color-text)', border: 0,
  borderRadius: 6, padding: '2px 8px', cursor: 'pointer', fontSize: 14,
};
